<template>
    <div>
        <div class="container content-page-wrapper projects-edit" :class="{'loading': loading}">
            <div class="row pt-5 pb-3">
                <div class="col-12">
                    <h1>{{ $t('User') }}: {{ userData.name }}</h1>
                    <div class="dropdown d-inline-block" v-if="$can('authenticate_customers') && userData.roles && userData.roles.indexOf('Superadmin') === -1">
                        <button class="btn btn-light btn-sm dropdown-toggle" type="button" :id="'user-edit-button-' + userData.id" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" :disabled="!$can('edit_users')">
                            <i class="far fa-edit"></i> {{ $t('Permissions') }}
                        </button>
                        <div class="dropdown-menu" :aria-labelledby="'user-edit-button-' + userData.id">
                            <a href="#" class="dropdown-item" @click="authorizeCustomer(userData.id)" :disabled="customerAuthorizing" v-if="$can('authenticate_customers') && userData.roles && userData.roles.indexOf('Customer') !== -1">{{ $t('Authorize customer') }}</a>
                            <a href="#" class="dropdown-item" @click="revokeCustomerAuthorization(userData.id)" :disabled="customerAuthorizing" v-if="$can('authenticate_customers') && userData.roles && userData.roles.indexOf('Authorized Customer') !== -1">{{ $t('Remove authorization') }}</a>
                            <a href="#" class="dropdown-item" @click="authorizeEmployee(userData.id)" :disabled="customerAuthorizing" v-if="$can('authenticate_customers') && userData.roles && ( userData.roles.indexOf('Customer') !== -1 || userData.roles.indexOf('Authorized Customer') !== -1)">{{ $t('Employee authorization') }}</a>
                            <a href="#" class="dropdown-item" @click="revokeEmployeeAuthorization(userData.id)" :disabled="customerAuthorizing" v-if="$can('authenticate_customers') && userData.roles && userData.roles.indexOf('Employee') !== -1">{{ $t('Remove employee authorization') }}</a>
                        </div>
                    </div>
                    <button class="btn btn-sm btn-light" href="#" @click.prevent="activateEditUser" v-if="$can('edit_users')"><i class="far fa-edit"></i> {{ $t('Edit user data') }}</button>
                    <router-link :to="{ name: 'users.index' }" tag="button" class="btn btn-sm btn-primary"><i class="fas fa-chevron-left"></i> {{ $t('Back to customer overview') }}</router-link>
                </div>
            </div>
            <div class="row" v-if="!editUser">
                <div class="col-12 col-md-6">
                    <table class="table table-light">
                        <thead class="thead-dark">
                            <tr>
                                <th class="lead" colspan="2">{{ $t('Company') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><strong>{{ $t('Company') }}</strong></td>
                                <td>{{ userData.name }}</td>
                            </tr>
                            <tr>
                                <td><strong>{{ $t('Address') }}</strong></td>
                                <td>{{ userData.street }}<br>{{ userData.zip_code }} {{ userData.city }}<br>{{ userData.country }}</td>
                            </tr>
                            <tr>
                                <td><strong>{{ $t('VAT no.') }}</strong></td>
                                <td>{{ userData.ustid }}</td>
                            </tr>
                            <tr>
                                <td><strong>{{ $t('Type') }}</strong></td>
                                <td>
                                    <span class="btn btn-sm btn-light" v-if="userData.roles && userData.roles.indexOf('Customer') !== -1">{{ $t('Customer') }}</span>
                                    <span class="btn btn-sm btn-success" v-if="userData.roles && userData.roles.indexOf('Authorized Customer') !== -1">{{ $t('Authorized customer') }}</span>
                                    <span class="btn btn-sm btn-primary" v-if="userData.roles && userData.roles.indexOf('Employee') !== -1">{{ $t('Employee') }}</span>
                                    <span class="btn btn-sm btn-primary" v-if="userData.roles && userData.roles.indexOf('Employeeadmin') !== -1">{{ $t('Employee admin') }}</span>
                                    <span class="btn btn-sm btn-primary" v-if="userData.roles && userData.roles.indexOf('Superadmin') !== -1">{{ $t('Admin') }}</span>
                                </td>
                            </tr>
                            <tr v-if="$can('view_discounts')">
                                <td><strong>{{ $t('Customer discount') }}</strong></td>
                                <td>{{ userData.user_project_discount }}%</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-12 col-md-6">
                    <table class="table table-light">
                        <thead class="thead-dark">
                        <tr>
                            <th class="lead" colspan="2">{{ $t('Contact person') }}</th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><strong>{{ $t('Name') }}</strong></td>
                                <td>{{ userData.first_name }} {{ userData.last_name }}</td>
                            </tr>
                            <tr>
                                <td><strong>{{ $t('Phone') }}</strong></td>
                                <td><a :href="'tel:' + userData.phone">{{ userData.phone }}</a></td>
                            </tr>
                            <tr>
                                <td><strong>{{ $t('E-mail') }}</strong></td>
                                <td><a :href="'mailto:' + userData.email">{{ userData.email }}</a></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="row" v-else>
                <div class="col-12">
                    <edit-account-form @clicked="cancelEdit" @formSubmitted="cancelEdit(); getUser();"></edit-account-form>
                </div>
            </div>
        </div>

        <show-user-projects></show-user-projects>

    </div>
</template>

<script>

import {mapGetters} from "vuex";

export default {

    data() {
        return {
            loading: false,
            product_configurator_id: 1,
            userData: {},
            editUser: false,
            userDeleting: false,
            customerAuthorizing: false,
        };
    },

    mounted() {
        this.getUser();
    },

    methods: {
        activateEditUser() {
            this.editUser = true
        },
        deactivateEditUser() {
            this.editUser = false
        },

        cancelEdit (value) {
            this.editUser = false
        },

        getUser() {
            this.loading = true;
            axios.get('/api/users/' + this.$route.params.id)
                .then(response => {
                    this.userData = response.data.data;
                    this.loading = false;
                }).catch(error => {
                    this.loading = false;
            });
        },

        authorizeCustomer(user_id) {
            this.$swal.fire({
                title: 'Kunde autorisieren?',
                text: "Wenn Sie diesen Kunden autorisieren, kann dieser Preise einsehen.",
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: '#3CA2A4',
                cancelButtonColor: '#393e42',
                confirmButtonText: "Ja, autorisieren!",
                cancelButtonText: "Abbrechen"
            }).then((result) => {
                if (result.value) {
                    this.customerAuthorizing = true;

                    axios.put('/api/users/' + user_id + '/authorize_customer')
                        .then(response => {
                            this.$swal.fire({
                                icon: 'success',
                                title: 'Erfolgreich autorisiert'
                            });
                            this.getUser();
                            this.customerAuthorizing = false;
                        }).catch(error => {
                        this.$swal.fire({ icon: 'error', title: 'Es ist ein Fehler aufgetreten'});
                        this.customerAuthorizing = false;
                    });

                }
            })
        },

        revokeCustomerAuthorization(user_id) {
            this.$swal.fire({
                title: 'Autorisierung entziehen?',
                text: "Wenn Sie diesen Kunden die Authorisierung entziehen, kann dieser keine Preise mehr einsehen.",
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: '#3CA2A4',
                cancelButtonColor: '#393e42',
                confirmButtonText: "Ja, entziehen!",
                cancelButtonText: "Abbrechen"
            }).then((result) => {
                if (result.value) {
                    this.customerAuthorizing = true;

                    axios.put('/api/users/' + user_id + '/revoke_customer_authorization')
                        .then(response => {
                            this.$swal.fire({
                                icon: 'success',
                                title: 'Authorisierung erfolgreich entzogen'
                            });
                            this.getUser();
                            this.customerAuthorizing = false;
                        }).catch(error => {
                        this.$swal.fire({ icon: 'error', title: 'Es ist ein Fehler aufgetreten'});
                        this.customerAuthorizing = false;
                    });

                }
            })
        },

        authorizeEmployee(user_id) {
            this.$swal.fire({
                title: 'Account in Mitarbeiter umwandeln?',
                text: "Durch diese Aktion erhält der User zahlreiche weitere Rechte.",
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: '#3CA2A4',
                cancelButtonColor: '#393e42',
                confirmButtonText: "Ja, autorisieren!",
                cancelButtonText: "Abbrechen"
            }).then((result) => {
                if (result.value) {
                    this.customerAuthorizing = true;
                    this.loading = true;

                    axios.put('/api/users/' + user_id + '/authorize_employee')
                        .then(response => {
                            this.$swal.fire({
                                icon: 'success',
                                title: 'Erfolgreich autorisiert'
                            });
                            this.getUser();
                            this.customerAuthorizing = false;
                            this.loading = false;
                        }).catch(error => {
                        this.$swal.fire({ icon: 'error', title: 'Es ist ein Fehler aufgetreten'});
                        this.customerAuthorizing = false;
                        this.loading = false;
                    });

                }
            })
        },

        revokeEmployeeAuthorization(user_id) {
            this.$swal.fire({
                title: 'In Kundenaccount umwandeln?',
                text: "Wenn Sie diesen Mitarbeiter die Authorisierung entziehen, verliert dieser zahlreiche Rechte.",
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: '#3CA2A4',
                cancelButtonColor: '#393e42',
                confirmButtonText: "Ja, umwandeln!",
                cancelButtonText: "Abbrechen"
            }).then((result) => {
                if (result.value) {
                    this.customerAuthorizing = true;

                    axios.put('/api/users/' + user_id + '/revoke_employee_authorization')
                        .then(response => {
                            this.$swal.fire({
                                icon: 'success',
                                title: 'Authorisierung erfolgreich entzogen'
                            });
                            this.getUser();
                            this.customerAuthorizing = false;
                        }).catch(error => {
                        this.$swal.fire({ icon: 'error', title: 'Es ist ein Fehler aufgetreten'});
                        this.customerAuthorizing = false;
                    });

                }
            })
        },

        deleteUser(user_id) {
            this.$swal.fire({
                title: 'Benutzer löschen?',
                text: "Nach dem Löschen kann der Account und die zugehörigen Projekte nicht wiederhergestellt werden.",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#e3342f',
                cancelButtonColor: '#393e42',
                confirmButtonText: "Ja, löschen!",
                cancelButtonText: "Abbrechen"
            }).then((result) => {
                if (result.value) {
                    this.userDeleting = true;
                    this.loading = true;
                    axios.delete('/api/users/' + user_id)
                        .then(response => {
                            this.$swal.fire({
                                icon: 'success',
                                title: 'Erfolgreich gelöscht'
                            });
                            this.getUser();
                            this.userDeleting = false;
                            this.loading = false;
                        }).catch(error => {
                        this.$swal.fire({
                            icon: 'error',
                            title: 'Es ist ein Fehler aufgetreten'
                        });
                        this.userDeleting = false;
                        this.loading = false;
                    });

                }
            })
        },

        /*updateUser() {
            this.projectFormSubmitting = true;
            axios.put('/api/projects/' + this.$route.params.id, this.projectFields )
                .then(response => {
                    this.$swal.fire({
                        icon: 'success',
                        title: 'Erfolgreich aktualisiert',
                        confirmButtonColor: '#3CA2A4'
                    });
                    this.projectFormSubmitting = false;
                    this.editUser = false;
                    this.getUser();
                }).catch(error => {
                this.$swal.fire({
                    icon: 'error',
                    title: 'Fehler aufgetreten',
                    text: 'Bitte überprüfen Sie das Formular',
                    confirmButtonColor: '#3CA2A4'
                });
                if (error.response.status === 422) { // Validation Error
                    this.projectFormErrors = error.response.data.errors;
                }
                this.projectFormSubmitting = false;
            });
        },

        deleteUser() {
            this.$swal.fire({
                title: 'Sind Sie sicher?',
                text: "Nach dem Löschen kann das Projekt nicht wiederhergestellt werden.",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#e3342f',
                cancelButtonColor: '#393e42',
                confirmButtonText: "Ja, löschen!",
                cancelButtonText: "Abbrechen"
            }).then((result) => {
                if (result.value) {
                    this.projectDeleting = true;

                    axios.delete('/api/projects/' + this.$route.params.id)
                        .then(response => {
                            this.$swal.fire({
                                icon: 'success',
                                title: 'Erfolgreich gelöscht'
                            });
                            this.projectDeleting = false;
                            this.$router.push({ name: 'projects.index' });
                        }).catch(error => {
                            this.$swal.fire({ icon: 'error', title: 'Es ist ein Fehler aufgetreten'});
                    });

                }
            })
        }, */

	},

    computed: {
        ...mapGetters({
            authenticated: 'auth/authenticated',
            user: 'auth/user',
            permissions: 'auth/permissions'
        }),
    }
};
</script>
